/**
 * ミッション進行に合わせて差し替える BGM（public/sounds/ の mp3）の URL 定義。
 *
 * 初期 BGM（各ミッションのループ。Sunrise 等）はシーン既定（public/scenes/*.json
 * の bgm。scripts/data/bgm-overrides.json で差し替え）としてプレイ開始時に鳴る。
 * ここに集約するのは、ミッション進行中の場面切替で BehaviorContext.setBgm へ渡す
 * 「差し替え先」の URL。複数ミッションで同じ曲を使う（クリア曲 ユメミライ は
 * RJF01/RJF06 共通）ため、URL の単一の出どころをここへ集約する（DRY）。
 *
 * 切替は BehaviorContext.setBgm が担う:
 *   ctx.setBgm?.(CLEAR_BGM_URL)
 */

/** ボス戦 BGM（Thunderbolt）。RJF01 のボスエリア進入・RJS12 のスタートで差し替える。 */
export const BOSS_BGM_URL = '/sounds/rjf01-bgm-boss-thunderbolt.mp3'

/** クリア BGM（ユメミライ）。RJF01・RJF06・RJS12 のクリアで差し替える。 */
export const CLEAR_BGM_URL = '/sounds/rjf01-bgm-clear-yumemirai.mp3'
